<div
  class="noti-box"
  [style.background-color]="color()"
  *ngIf="useContent() || message()"
>
  <ng-container [ngSwitch]="type()">
    <i class="material-symbols-outlined" *ngSwitchCase="'error'">warning</i>
    <i class="material-symbols-outlined" *ngSwitchCase="'info'">info</i>
    <i class="material-symbols-outlined" *ngSwitchCase="'news'">description</i>
  </ng-container>

  <div class="limit-width">
  @if (useContent()) {
    <ng-content *ngIf="useContent()"></ng-content>
  } @else {
    <p class="mb-0" *ngIf="message() as message">{{ message }}</p>
  }
  </div>
</div>
